import LiveTvIcon from '@material-ui/icons/LiveTv';
export const ThemaIcon = LiveTvIcon